/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

//MATERIAL
import {
  withStyles,
  createTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
// CSS

import cssStyles from "./webPayPaymentSettings.module.css";

//IMPORTS
import {
  getAllPayments as getPayments,
  updatePayment,
} from "../../../../reducers/paymentSlice";
import paymentsConstants from "../../../../constants/payments.constants";
import { Notification } from "../../../../containers/notification";
import { selectUser } from "../../../../reducers/userSlice";
import mongoose from "mongoose";
import {
  loadingOff,
  loadingOn,
  selectLoadingUI,
} from "../../../../reducers/uiSlice";
import { selectCompany, getCompany } from "../../../../reducers/companySlice";
import { useChangeRecord } from "../../../../utils/hooks/useChangeRecord";
import companyService from "../../../../utils/services/company";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../../reducers/depositSlice";
import dateUtils from "../../../../utils/date";
import InputComponent from "../../../inputs";
import { useNavigate } from "react-router-dom";
import { selectSubsidiaries } from "../../../../reducers/subsidiarySlice";
import { Tab, Tabs } from "@material-ui/core";
import lumaUtils from "@lumarketo/luma-utils";
import config from "../../../../utils/config";
import paymentsService from "../../../../utils/services/payments";

const defaultData = (company) => ({
  name: paymentsConstants.TYPES.Webpay,
  factor: 1,
  duration: 60,
  startTime: "01:00",
  endTime: "23:59",
  details: [],
  useSandbox: false,
  _id: new mongoose.Types.ObjectId().toHexString(),
  IdCompany: company._id,
  subsidiaryId: "",
});

function WebPayPaymentSettings(props) {
  const company = useSelector(selectCompany);
  const [apiSecret, setApiSecret] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [updated, setUpdated] = useState(false);
  const [payment, setPayment] = useState(null);
  const [useWebpay, setUseWebPay] = useState(false);
  const [useSandbox, setUseSandbox] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const [payments, setPayments] = useState([]);
  const subsidiaries = useSelector(selectSubsidiaries);
  const { enqueueSnackbar } = useSnackbar();
  const changes = useSelector(selectChangesDeposit);
  const dispatch = useDispatch();
  const { recordChange } = useChangeRecord();
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const [subsidiaryId, setSubsidiaryId] = useState(subsidiaries[0]?._id ?? "");
  const webPayLogo = "https://dgdvd9d8e5bk8.cloudfront.net/webpageLogoPng.png";
  const isLoading = useSelector(selectLoadingUI);

  // then inside a useEffect
  useEffect(() => {
    if (company?._id) setPayment(defaultData(company));
  }, [company?._id]);

  useEffect(() => {
    if (subsidiaries?.length > 0 && subsidiaries[0]?._id)
      setSubsidiaryId(subsidiaries[0]._id);
  }, [subsidiaries]);

  useEffect(() => {
    setUseWebPay(company?.UsePayments?.useWebpay ? true : false);
    if (company?.Payments) {
      const found = company?.Payments.filter(
        (item) => item.name === paymentsConstants.TYPES.Webpay
      );
      if (found.length > 0) {
        setPayments(found);
        setUpdated(false);
      }
    }
  }, [company?.Payments, company.UsePayments]);

  useEffect(() => {
    function getData() {
      const { useSubsidiaryPayment } = company;
      const found = payments.find((item) =>
        !useSubsidiaryPayment
          ? item.name === paymentsConstants.TYPES.Webpay && !item.subsidiaryId
          : item.name === paymentsConstants.TYPES.Webpay &&
            item.subsidiaryId === subsidiaryId
      );
      if (found) setPayment(found);
      else setPayment(defaultData(company));

      setUpdated(false);
    }

    if (
      (subsidiaryId !== "" || !company.useSubsidiaryPayment) &&
      payments.length
    )
      getData();
  }, [subsidiaryId, company.useSubsidiaryPayment, payments.length]);

  useEffect(() => {
    let isMounted = true; // flag to control if we are still mounted

    const runDecryption = async () => {
      setUpdated(false);

      if (
        payment?.details?.length > 0 &&
        isMounted &&
        subsidiaryId &&
        subsidiaryId === payment?.subsidiaryId
      ) {
        const detail = payment?.details?.[0];

        setUseSandbox(payment?.useSandbox);
        try {
          dispatch(loadingOn());
          if (
            config?.secretKey &&
            config?.secretIv &&
            detail?.apiKey &&
            detail?.apiSecret
          ) {
            const decryptedApiKey =
              await lumaUtils.secretManagementUtils.deencript(
                detail?.apiKey,
                config?.secretKey,
                config?.secretIv
              );
            if (decryptedApiKey) {
              setApiKey(decryptedApiKey);
            } else {
              console.error(
                "decryptedApiKey returned empty or failed for value:",
                detail?.apiKey
              );
              setApiKey("");
            }

            const decryptedSecretKey =
              await lumaUtils.secretManagementUtils.deencript(
                detail?.apiSecret,
                config?.secretKey,
                config?.secretIv
              );
            if (decryptedSecretKey) {
              setApiSecret(decryptedSecretKey);
            } else {
              console.error(
                "decryptedSecretKey returned empty or failed for value:",
                detail?.apiSecret
              );
              setApiSecret("");
            }
          } else {
            setApiKey("");
            setApiSecret("");
          }
        } catch (error) {
          console.error("Unexpected error on getting the secret keys:", error);
          setApiKey("");
          setApiSecret("");
        } finally {
          dispatch(loadingOff());
        }
      } else {
        setApiKey("");
        setApiSecret("");
      }
    };
    runDecryption();

    return () => {
      isMounted = false; // when unmounting, set to false
    };
  }, [payment, subsidiaryId]);

  const handleCancel = () => {
    const detail = payment.details[0];
    setApiSecret(detail.apiSecret);
    setApiKey(detail.apiKey);
    setUpdated(false);
  };

  const handleSave = async () => {
    try {
      dispatch(loadingOn());

      const encryptedApiKey = await lumaUtils.secretManagementUtils.encript(
        apiKey,
        config.secretKey,
        config.secretIv
      );
      const encryptedApiSecret = await lumaUtils.secretManagementUtils.encript(
        apiSecret,
        config.secretKey,
        config.secretIv
      );

      if (encryptedApiKey && encryptedApiSecret) {
        const updatedPayment = {
          ...payment,
          IdCompany: company._id,
          subsidiaryId,
          useSandbox,
          details: [
            {
              ...payment.details[0],
              apiSecret: encryptedApiSecret,
              apiKey: encryptedApiKey,
            },
          ],
        };

        await updatePayment(updatedPayment, user.token);
        await handleCompanySave();

        setPayment(updatedPayment);
        setUpdated(false);
        getPayments(company._id, user.token, dispatch);

        enqueueSnackbar(
          Notification({
            text: "Métodos de pagos actualizados",
            variant: "success",
            withDetails: false,
          })
        );
      } else {
        enqueueSnackbar(
          Notification({
            text: "Métodos de pagos no fueron actualizados",
            variant: "error",
            withDetails: false,
          })
        );
      }
    } catch (error) {
      console.error("error trying to save credentials", error);
      enqueueSnackbar(
        Notification({
          text: "Error al actualizar métodos de pago",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      dispatch(loadingOff());
    }
  };

  const handleCompanySave = async () => {
    try {
      await companyService.updateCompany(
        company._id,
        {
          _id: company._id,
          UsePayments: {
            ...company.UsePayments,
            useWebpay,
          },
        },
        user.token
      );

      await getCompany(company._id, dispatch);
      enqueueSnackbar(
        Notification({
          text: "Datos de la tienda actualizados",
          variant: "success",
          withDetails: false,
        })
      );
      setUpdated(false);
      recordChange({
        module: "Métodos de pago",
        submodule: "WebPay",
        subsidiaryId,
        changes: changes,
      });
    } catch (err) {
      enqueueSnackbar(
        Notification({
          text: "Error al actualizar datos de la tienda",
          variant: "error",
          withDetails: false,
        })
      );
    }
  };

  const updateChanges = (fieldName, newValue) => {
    const newChanges = [];
    newChanges.push(...changes);
    var index = -1;
    const change = {
      text: "",
      oldValue: null,
      newValue: null,
      date: dateUtils.getUTC().slice(0, 19).replace("T", " "),
    };

    change.newValue = newValue;
    change.oldValue = company && company[fieldName] ? company[fieldName] : "";

    switch (fieldName) {
      case "useWebpay":
        change.text = "Usar método de pago WebPay";
        change.oldValue = company.UsePayments[fieldName];
        break;
      default:
        break;
    }

    index = newChanges.findIndex(
      (item) => item.text.toString() === change.text.toString()
    );

    if (index !== -1) {
      change.oldValue = newChanges[index].oldValue;
      newChanges[index] = change;
    } else {
      newChanges.push(change);
    }
    dispatch(setChanges(newChanges));
  };

  const handleUsePayment = (event, name) => {
    switch (name) {
      case "useWebpay":
        setUseWebPay(event.target.checked);
        updateChanges("useWebpay", event.target.checked);
        break;
      default:
        break;
    }
    setUpdated(true);
  };

  const handleClose = () => {
    navigate(-1);
  };

  const handleDeleteCredential = async (id, token) => {
    dispatch(loadingOn());
    try {
      const deleteCredentials = await paymentsService.deletePaymentCredentials(
        id,
        token
      );
      if (deleteCredentials) {
        enqueueSnackbar(
          Notification({
            text: "Se ha eliminado la credencial de WebPay para la sucursal seleccionada",
            variant: "success",
            withDetails: false,
          })
        );
        setApiKey("");
        setApiSecret("");
        await getPayments(company._id, user.token, dispatch);
      }
    } catch (error) {
      console.error("error", error);
      enqueueSnackbar(
        Notification({
          text: "Error al tratar de eliminar credenciales de pago",
          variant: "error",
          withDetails: false,
        })
      );
    } finally {
      dispatch(loadingOff());
    }
  };

  return (
    <MuiThemeProvider theme={theme}>
      <div className={cssStyles.parentContainer}>
        <button className={cssStyles.backButton} onClick={() => handleClose()}>
          <span>
            <ArrowBackIcon />
          </span>
          Regresar
        </button>
        <div className={cssStyles.infoContainer}>
          <div className={cssStyles.titleLogoContainer}>
            <div className={cssStyles.containerLogo}>
              <img src={webPayLogo} alt="webPay" width={200} />
            </div>
            <div className={cssStyles.serviceStatusContainer}>
              {!useWebpay ? (
                <div className={cssStyles.containerLogo}>
                  <img
                    className="stateOffMargin"
                    src="https://s3.amazonaws.com/lumarketo.cl/clock-steps-home.svg"
                    alt=""
                  />
                  Inactivo{" "}
                </div>
              ) : (
                <div className={cssStyles.containerLogo}>
                  {" "}
                  <img
                    src="https://s3.amazonaws.com/lumarketo.cl/check-steps-home.svg"
                    alt=""
                  />{" "}
                  Activo{" "}
                </div>
              )}
            </div>
          </div>
          <div className={cssStyles.infoItemContainer}>
            <p className={cssStyles.infoItemTitle}>
              Permite a tus clientes pagar con
            </p>

            <div className={cssStyles.outerContainerLogo}>
              <div className={cssStyles.containerLogo}>
                <img
                  className="mercadoPagoheaderTextLogoSize"
                  src="https://s3.amazonaws.com/lumarketo.cl/tarjeta-de-credito-mercadopago.svg"
                  alt=""
                />
                <p className={cssStyles.infoItemTitlePayment}>
                  {" "}
                  Tarjeta de Débito/Crédito
                </p>
              </div>
              <div className={cssStyles.containerLogo}>
                <img
                  className="mercadoPagoheaderTextLogoSize"
                  src="https://s3.amazonaws.com/lumarketo.cl/mensual-removebg-preview-calendario-mercadopago.svg"
                  alt=""
                />
                <p className={cssStyles.infoItemTitlePayment}>
                  {" "}
                  Cuotas sin interés
                </p>
              </div>
            </div>
          </div>
          <div className={cssStyles.infoItemContainer}>
            <p className={cssStyles.infoItemTitle}>
              WebPay de Transbank te ofrece una única manera de como obtener el
              dinero acumulado
            </p>
            <div className={cssStyles.descriptionContainer}>
              <div className={cssStyles.descriptionInnerContainer}>
                <p className={cssStyles.infoItem}>Pagas</p>
                <p className={cssStyles.infoItem}>
                  <span className="porcentageNumber"> 1,45% </span> (rubro
                  gastronómico)
                </p>
              </div>
              <div className={cssStyles.descriptionInnerContainer}>
                <p className={cssStyles.infoItem}>Retiras tu dinero en</p>
                <p className={cssStyles.infoItem}>
                  <span className="porcentageNumber">
                    {" "}
                    24 a 72 horas hábiles{" "}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className={cssStyles.descriptionContainer}>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://ayuda.transbank.cl/activar-webpay-plus"
            >
              {" "}
              <span className="mercadopagoFotterButtonBlank">
                Ver: ¿Cómo configurar Webpay?
              </span>
            </a>
            <p className={cssStyles.infoItem}>
              Pago seguro{" "}
              <img
                src="https://s3.amazonaws.com/lumarketo.cl/tarjeta-fondo-background.svg"
                alt=""
              />
            </p>
          </div>
          <button
            className={cssStyles.buttonConfig}
            onClick={() => {
              setShowInputs((p) => !p);
            }}
          >
            Configurar
            <span>{!showInputs ? <ExpandMoreIcon /> : <ExpandLessIcon />}</span>
          </button>
          {showInputs && company.useSubsidiaryPayment && (
            <Tabs
              value={subsidiaryId}
              indicatorColor="primary"
              textColor="primary"
              onChange={(event, newValue) => setSubsidiaryId(newValue)}
              aria-label="disabled tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              {subsidiaries.map((item) => (
                <Tab label={item.Name} value={item._id} key={item?._id} />
              ))}
            </Tabs>
          )}
          {showInputs && (
            <div className={cssStyles.configSettingsContainer}>
              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Public Key</label>

                <InputComponent
                  placeholder="12345678"
                  type="text"
                  validation={apiKey === ""}
                  helperText={
                    apiKey === "" ? "Recuerde indicar la public key" : ""
                  }
                  value={apiKey}
                  handler={(e) => {
                    setApiKey(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>
              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Access Token</label>

                <InputComponent
                  placeholder="12345678"
                  type="text"
                  validation={apiSecret === ""}
                  helperText={
                    apiSecret === ""
                      ? "Recuerde indicar el token de acceso"
                      : ""
                  }
                  value={apiSecret}
                  handler={(e) => {
                    setApiSecret(e.target.value);
                    setUpdated(true);
                  }}
                />
              </div>

              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Activar Sandbox</label>
                <Checkbox
                  style={{
                    color: "#122526",
                    margin: "0px 5px",
                    padding: 0,
                  }}
                  checked={useSandbox}
                  onChange={(e) => {
                    setUpdated(true);
                    setUseSandbox(e.target.checked);
                  }}
                  value={useSandbox.toString()}
                  color="primary"
                  id={"useSandbox"}
                />
              </div>
              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>
                  Eliminar credenciales
                </label>
                <button
                  className={cssStyles.buttonDelete}
                  type="button"
                  onClick={() =>
                    handleDeleteCredential(payment?._id, user?.token)
                  }
                >
                  <DeleteOutlineIcon />
                </button>
              </div>
              <br />
              <div
                style={{
                  margin: "5px 0px",
                  borderBottom: "1px solid gray",
                }}
              />
              <br />
              <div className={cssStyles.inputContainer}>
                <label className={cssStyles.labelInput}>Activar</label>
                <Checkbox
                  style={{
                    color: "#122526",
                    margin: "0px 5px",
                    padding: 0,
                  }}
                  checked={useWebpay}
                  onChange={(e) => handleUsePayment(e, "useWebpay")}
                  value={useWebpay.toString()}
                  color="primary"
                  id={"useWebpay"}
                />
              </div>
            </div>
          )}
          {showInputs && (
            <div className={cssStyles.buttonsContainer}>
              <button
                className={cssStyles.cancelButton}
                disabled={!updated || isLoading}
                onClick={() => handleCancel()}
              >
                Cancelar
              </button>
              <button
                className={cssStyles.confirmButton}
                disabled={!updated || isLoading}
                onClick={() => handleSave()}
              >
                Guardar
              </button>
            </div>
          )}
        </div>
      </div>
    </MuiThemeProvider>
  );
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginTop: "5%",
    [theme.breakpoints.up("xs")]: {
      marginTop: "15%",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "5%",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "1%",
    },
  },
  centerTitle: {
    textAlign: "center",
  },
  componentDescription: {
    padding: "0 5px",
  },
  componentContainerFab: {
    display: "flex",
    position: "absolute",
    top: "90%",
  },
  componentHeading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  componentSecondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  textField: {
    width: "100%",
    margin: "5px 0 5px 0px",
  },
  bankTextField: {
    width: "100%",
  },
  unknowBankTextField: {
    width: "86%",
  },
  componentAddItem: {
    display: "flex",
    justifyContent: "center",
  },
  bankCard: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex",
    height: 360,
    width: 450,
    marginBottom: 10,
  },
  cover: {
    width: 200,
    backgroundRepeat: "round",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    width: 250,
  },
  content: {
    flex: "1 0 auto",
  },
  deleteIcon: {
    position: "absolute",
    left: "88%",
    top: "-2%",
  },
  subtitleContainer: {
    margin: "auto 0px",
  },
});

const theme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: "Roboto, sans-serif !important",
  },
  palette: {
    primary: { main: "#122526" },
  },
  overrides: {
    MuiFormGroup: {
      root: {
        flexDirection: "column !important",
      },
    },
    MuiFormControlLabel: {
      root: {
        marginBottom: "-5%",
        marginLeft: "5%",
      },
    },
    MuiFormLabel: {
      root: {
        color: "#122526 !important",
      },
    },
    MuiInput: {
      underline: {
        "&:hover:not($disabled):before": {
          borderBottom: "2px solid #122526",
        },
        "&:after": {
          borderBottom: "2px solid #122526",
        },
        "&:before": {
          // borderBottom: '2px solid #122526'
        },
      },
    },
    MuiFormControl: {
      root: {
        width: 100,
        margin: "0px 5px",
      },
    },
    MuiCardHeader: {
      root: {
        background: "#122526",
      },
      title: {
        color: "white",
      },
    },
  },
});

export default withStyles(styles)(WebPayPaymentSettings);
